export const NOTIFY_USER = "NOTIFY_USER";
export const ALLOW_REGISTRATION = "ALLOW_REGISTRATION";
